import * as React from 'react';

import { DataConnections } from '~src/connectivity/resources/DataConnections';

import { Messages } from '../../../codegen/Localize';
import { IDataConnectionInfo } from '../../../ts/models/IDataConnectionInfo';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { ConnectionDisplay } from '../ListView/DataConnectionComponents';
import { CardTextAndLink } from './CardTextAndLink';
import { CardViewStyles } from './CardViewStyles';

export interface DataconnectionThumbnailProps extends SiteUrlsProps {
  readonly dataconnection: IDataConnectionInfo;
  readonly datasourceContentUrl: string;
  readonly metadata: ConnectionDisplay.Metadata;
  readonly hoveredOrSelected?: boolean;
}

export class DataconnectionThumbnail extends React.Component<DataconnectionThumbnailProps> {
  public render() {
    const containerClass = this.props.hoveredOrSelected ?
      (this.cardUrl() ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnailHoverNoPointer)
      : CardViewStyles.CustomThumbnail;
    /* eslint-disable jsx-a11y/alt-text */
    /* eslint-disable jsx-a11y/anchor-has-content */
    return (
      <div className={containerClass}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={CardViewStyles.DataconnectionThumbnailDatasourceLink}>
              <CardTextAndLink
                text={Messages.datasource()}
                url={this.props.datasourceContentUrl}
                urlDisplayName={this.props.dataconnection.datasource.name}
                marginLeft={12 /*The hover checkbox doesn't cover the text*/} />
            </div>
            <div className={CardViewStyles.CustomThumbnailImg}>
              <img src={this.props.metadata.cardIconUrl}/>
            </div>
          </div>
        </div>
        <div className={CardViewStyles.DataconnectionThumbnailConnectionType}>
          {this.props.metadata.connectionType}
        </div>
        <div>
          <React.Fragment>
            <div>
              {this.authentication()}
            </div>
            <div className={CardViewStyles.DataconnectionThumbnailUsername}>
              {DataConnections.getDisplayUsername(this.props.dataconnection) || <span>&nbsp;</span>}
            </div>
          </React.Fragment>
        </div>
        {this.cardUrl() && <a href={this.cardUrl()} className={CardViewStyles.AnchorUnderlay}></a>}
      </div>
    );
  }

  private cardUrl = (): string => {
    return this.props.metadata.href || this.props.datasourceContentUrl;
  }

  private authentication(): string {
    const authentication = DataConnections.getDisplayAuthentication(this.props.dataconnection);
    if (authentication === Messages.none()) {
      return Messages.editDataConnections_generic_noCredential();
    }

    return authentication;
  }
}
